// Small, generic debounce hook - engine-side copy of
// src/studio/editor/useDebouncedValue.ts. The engine never imports from
// src/studio (this is a published package boundary; external consumers like
// Dwindling only get src/engine), so ObjectBrowser.tsx needs its own copy
// rather than reaching across it. Kept identical on purpose.
import { useEffect, useState } from 'react';

/**
 * Returns `value`, but only updates to a new one after `delayMs` has passed
 * with no further change.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
